__webpack_require__.p = "/assets/widget/";